export default __webpack_public_path__ + "static/media/app-portafoglio.e18a458c.png";